import React from 'react';

import withPage from '../page';
import SeoMetaData from './components/seo-meta-data';
import AEMBannerContainer from './components/aemBannerContainer';
import VWAContent from './vwa-content';
import VWAIntopicArticles from './components/vwa-intopic-articles';
import FooterLogo from '../shared/components/footer-logo';
import CompareDrawer from '../compare/components/compare-drawer';
import VWAHeader from './components/vwa-header';

function VWAContainer({ slugInfo, history, location, pStoreID }) {
    const { partnerLogos } = slugInfo?.components || {};

    return (
        <>
            <div className="vwa-page">
                <VWAHeader location={location} />
                {!pStoreID && <AEMBannerContainer />}
                <VWAContent slugInfo={slugInfo} history={history} location={location} />
            </div>
            <VWAIntopicArticles />
            <FooterLogo logos={partnerLogos?.logos} breakpoint={1024} location={location} />
            <CompareDrawer />
        </>
    );
}

export default withPage(VWAContainer, {
    SeoMetaDataComponent: SeoMetaData,
    wrapperClassName: 'vwa-root',
    showWordCloud: true,
    useV2: true,
    useGraphQL: true,
    forwardQueryParams: ['orderBy'],
    derivedPath: (match, search) => {
        //vwa includes path and all filters, this will help prevent an extra API call on mount
        const { params, url } = match;
        const { dir } = params;
        const [baseName, vanitySlug] = url.split(dir);
        return `${dir}${vanitySlug}`;
    },
    derivedStatus: slugInfo => {
        const { components, seo } = slugInfo;
        const { finderResults } = components || {};
        const { status } = seo || {};
        const { status: finderStatus } = finderResults || {};
        if (finderStatus === 404 && status === 404) {
            return 404;
        }
    },
});
